export default function CreatedPage() {
    return (
        <div>
            <h1>Demande envoyée</h1>
            <p>Votre demande a bien été envoyée, un administrateur va maintenant l'examiner.</p>
            <p>Vous pouvez fermer cette fenêtre</p>
        </div>
    );
}
